<template>
  <div class="v-details-inner-form">
    <div class="form__heading">
      <h2 class="form__title">{{ subscriptions }} {{ i + 2 }}</h2>
    </div>
    <ul class="form__list">
      <li class="form__item form__item--no-label">
        <v-radios-public
          v-if="extra_tenants[i]"
          :name="`person[` + extra_tenants[i].id + `][title_id]`"
          :options="usersTitleOptions"
          :value="extra_tenants[i].title_id"
          v-validate="`required|make_choice`"
        ></v-radios-public>
        <v-radios-public
          v-else
          :name="`new_person[` + [i] + `][title_id]`"
          :options="usersTitleOptions"
          v-validate="`required|make_choice`"
        ></v-radios-public>
      </li>
      <li class="form__item">
        <v-radios-public
          v-if="extra_tenants[i]"
          :label="locales && locales.users && locales.users.language"
          :value="extra_tenants[i].language"
           :name="`person[` + extra_tenants[i].id + `][language]`"
          show-zero-option="0"
          :options="languages"
          v-validate="`required`"
        ></v-radios-public>
        <v-radios-public
          v-else
          :label="locales && locales.users && locales.users.language"
          :name="`new_person[` + [i] + `][language]`"
          show-zero-option="0"
          :options="languages"
          v-validate="`required`"
        ></v-radios-public>
      </li>
      <li class="form__item">
        <v-textfield-public
          v-if="extra_tenants[i]"
          :label="usersFirstName"
          :name="`person[` + extra_tenants[i].id + `][first_name]`"
          v-model="extra_tenants[i].first_name"
          v-validate="`required|alpha_spaces_dash`"
        ></v-textfield-public>
        <v-textfield-public
          v-else
          :label="usersFirstName"
          :name="`new_person[` + [i] + `][first_name]`"
          v-validate="`required|alpha_spaces_dash`"
        ></v-textfield-public>
      </li>
      <li class="form__item">
        <v-textfield-public
          v-if="extra_tenants[i]"
          :label="usersMiddleName"
          :name="`person[` + extra_tenants[i].id + `][middle_name]`"
          v-model="extra_tenants[i].middle_name"
        ></v-textfield-public>
        <v-textfield-public
          v-else
          :label="usersMiddleName"
          :name="`new_person[` + [i] + `][middle_name]`"
        ></v-textfield-public>
      </li>
      <li class="form__item">
        <v-textfield-public
          v-if="extra_tenants[i]"
          :label="usersLastName"
          :name="`person[` + extra_tenants[i].id + `][last_name]`"
          v-model="extra_tenants[i].last_name"
          v-validate="`required|alpha_spaces_dash`"
        ></v-textfield-public>
        <v-textfield-public
          v-else
          :label="usersLastName"
          :name="`new_person[` + [i] + `][last_name]`"
          v-validate="`required|alpha_spaces_dash`"
        ></v-textfield-public>
      </li>
      <li class="form__item">
        <v-textfield-public
          v-if="extra_tenants[i]"
          :name="`person[` + extra_tenants[i].id + `][address][post_code]`"
          :label="locales && locales.users && locales.users.post_code"
          @blur="checkPcHn($event, i)"
          class="js-postcode"
          v-model="extra_tenants[i].address.post_code"
        ></v-textfield-public>
        <v-textfield-public
          v-else
          :name="`new_person[` + [i] + `][address][post_code]`"
          :ref="`new_person_postcode_` + i"
          :label="locales && locales.users && locales.users.post_code"
          @blur="checkPcHn($event, i)"
          class="js-postcode"
        ></v-textfield-public>
      </li>
      <li class="form__item">
        <v-textfield-public
          v-if="extra_tenants[i]"
          :name="`person[` + extra_tenants[i].id + `][address][house_number]`"
          :label="locales && locales.users && locales.users.house_number"
          class="js-house-number"
          @blur="checkPostcodeAddress($event, i)"
          v-model="extra_tenants[i].address.house_number"
        ></v-textfield-public>
        <v-textfield-public
          v-else
          :name="`new_person[` + [i] + `][address][house_number]`"
          :ref="`new_person_house_number_` + i"
          :label="locales && locales.users && locales.users.house_number"
          class="js-house-number"
          @blur="checkPostcodeAddress($event, i)"
        ></v-textfield-public>
      </li>
      <li class="form__item">
        <v-textfield-public
          v-if="extra_tenants[i]"
          :name="`person[` + extra_tenants[i].id + `][address][street]`"
          :label="locales && locales.users && locales.users.street"
          v-model="extra_tenants[i].address.street"
        ></v-textfield-public>
        <v-textfield-public
          v-else
          :name="`new_person[` + [i] + `][address][street]`"
          :ref="`new_person_street_` + i"
          :label="locales && locales.users && locales.users.street"
        ></v-textfield-public>
      </li>
      <li class="form__item">
        <v-textfield-public
          v-if="extra_tenants[i]"
          :is-update-model="true"
          :name="`person[` + extra_tenants[i].id + `][address][city]`"
          :label="locales && locales.users && locales.users.city"
          v-model="extra_tenants[i].address.city"
        ></v-textfield-public>
        <v-textfield-public
          v-else
          :is-update-model="true"
          :name="`new_person[` + [i] + `][address][city]`"
          :ref="`new_person_city_` + i"
          :label="locales && locales.users && locales.users.city"
        ></v-textfield-public>
      </li>
      <li class="form__item">
        <v-datepicker-public
          v-if="extra_tenants[i]"
          :label="usersDateOfBirth"
          :name="`person[` + extra_tenants[i].id + `][birthdate]`"
          :value="extra_tenants[i].bDate"
          v-validate="`required`"
        ></v-datepicker-public>
        <v-datepicker-public
          v-else
          :label="usersDateOfBirth"
          :name="`new_person[` + [i] + `][birthdate]`"
          v-validate="`required`"
        ></v-datepicker-public>
      </li>
      <li class="form__item">
        <v-textfield-public
          v-if="extra_tenants[i]"
          :label="usersPhoneNumber"
          :name="`person[` + extra_tenants[i].id + `][phone_number]`"
          v-model="extra_tenants[i].phone_number"
          class="js-unique-phone"
          @blur="checkPhone"
          v-validate="`required|phone_number`"
        ></v-textfield-public>
        <v-textfield-public
          v-else
          :label="usersPhoneNumber"
          :name="`new_person[` + [i] + `][phone_number]`"
          class="js-unique-phone"
          @blur="checkPhone"
          v-validate="`required|phone_number`"
        ></v-textfield-public>
      </li>
      <li class="form__item" v-if="!!is_phone_number_unique">
        <label class="form__label"></label>
        <b style="color: red">{{ incomePhoneNumberAlreadyExists }}</b>
        <input
          type="hidden"
          name="phone_number_unique"
          v-validate="`required`"
        />
      </li>
      <li class="form__item">
        <v-textfield-public
          v-if="extra_tenants[i]"
          :label="usersEmail"
          :name="`person[` + extra_tenants[i].id + `][email]`"
          v-model="extra_tenants[i].email"
          class="js-unique-mail"
          @blur="checkMail($event, extra_tenants[i].id)"
          type="email"
          v-validate="`required|email`"
        ></v-textfield-public>
        <v-textfield-public
          v-else
          :label="usersEmail"
          :name="`new_person[` + [i] + `][email]`"
          class="js-unique-mail"
          type="email"
          @blur="checkMail"
          v-validate="`required|email`"
        ></v-textfield-public>
      </li>
      <li class="form__item" v-if="is_user_already_exists == 1">
        <label class="form__label"></label>
        <b style="color: red">{{ isUserAlreadyExists }}</b>
        <input
          type="hidden"
          name="user_already_exists"
          v-validate="`required`"
        />
      </li>
      <li class="form__item" v-if="is_user_already_exists == 2">
        <label class="form__label"></label>
        <b style="color: red">{{ isUserBanned }}</b>
        <input
          type="hidden"
          name="user_already_exists"
          v-validate="`required`"
        />
      </li>
      <li class="form__item">
        <v-textfield-public
          v-if="extra_tenants[i]"
          :label="usersInvoiceEmail"
          :name="`person[` + extra_tenants[i].id + `][invoice_mail]`"
          v-model="extra_tenants[i].invoice_mail"
          type="email"
          v-validate="`email`"
        ></v-textfield-public>
        <v-textfield-public
          v-else
          :label="usersInvoiceEmail"
          :name="`new_person[` + [i] + `][invoice_mail]`"
          type="email"
          v-validate="`email`"
        ></v-textfield-public>
      </li>
      <li class="form__item">
        <v-textfield-public
          v-if="extra_tenants[i]"
          :label="usersBankAccount"
          :name="`person[` + extra_tenants[i].id + `][bank_account]`"
          v-model="extra_tenants[i].bank_account"
        ></v-textfield-public>
        <v-textfield-public
          v-else
          :label="usersBankAccount"
          :name="`new_person[` + [i] + `][bank_account]`"
        ></v-textfield-public>
      </li>
      <li class="form__item">
        <v-textfield-public
          v-if="extra_tenants[i]"
          :label="usersBic"
          :name="`person[` + extra_tenants[i].id + `][bic]`"
          v-model="extra_tenants[i].bic"
        ></v-textfield-public>
        <v-textfield-public
          v-else
          :label="usersBic"
          :name="`new_person[` + [i] + `][bic]`"
        ></v-textfield-public>
      </li>
      <li class="form__item">
        <v-select-public
          v-if="extra_tenants[i]"
          :label="usersCivilState"
          :value="extra_tenants[i].civil_state_id"
          :name="`person[` + extra_tenants[i].id + `][civil_state_id]`"
          :options="usersCivilStateOptions"
          v-validate="`required`"
        ></v-select-public>
        <v-select-public
          v-else
          :label="usersCivilState"
          :name="`new_person[` + [i] + `][civil_state_id]`"
          :options="usersCivilStateOptions"
          v-validate="`required`"
        ></v-select-public>
      </li>
    </ul>
    <div class="form__heading">
      <h2 class="form__title">
        {{ subscriptions }} {{ i + 2 }} {{ incomeTitle }}
      </h2>
    </div>
    <ul class="form__list">
      <li class="form__item">
        <v-checkboxes-public
          v-if="extra_tenants[i]"
          :label="usersIAm"
          :name="`person[` + extra_tenants[i].id + `][type_of_income][]`"
          :options="usersTypeOfIncomeOptions"
          :values="extra_tenants[i].types_of_income_array"
          @input="triggerIncomeAdditionalForms"
          v-validate="`required|make_choice`"
        ></v-checkboxes-public>
        <v-checkboxes-public
          v-else
          :label="usersIAm"
          :name="`new_person[` + [i] + `][type_of_income][]`"
          :options="usersTypeOfIncomeOptions"
          @input="triggerIncomeAdditionalForms"
          v-validate="`required|make_choice`"
        ></v-checkboxes-public>
      </li>
      <!-- working or business -->
      <template v-if="income_form_work_business">
        <li class="form__item" v-if="income_form_work">
          <v-radios-public
            v-if="extra_tenants[i]"
            :label="usersContractType"
            :name="
              `person[` + extra_tenants[i].id + `][working_contract_type_id]`
            "
            v-model="extra_tenants[i].working_contract_type_id"
            :options="usersContractTypeOptions"
            @input="triggerContractDuration"
            v-validate="`required|make_choice`"
          ></v-radios-public>
          <v-radios-public
            v-else
            :label="usersContractType"
            :name="`new_person[` + [i] + `][working_contract_type_id]`"
            :options="usersContractTypeOptions"
            @input="triggerContractDuration"
            v-validate="`required|make_choice`"
          ></v-radios-public>
        </li>
        <template v-if="showDuration && income_form_work">
          <li class="form__item">
            <v-textfield-public
              v-if="extra_tenants[i]"
              v-model="extra_tenants[i].working_contract_duration"
              :label="usersContractDuration"
              :name="
                `person[` + extra_tenants[i].id + `][working_contract_duration]`
              "
              v-validate="`required|numeric`"
            ></v-textfield-public>
            <v-textfield-public
              v-else
              :label="usersContractDuration"
              :name="`new_person[` + [i] + `][working_contract_duration]`"
              v-validate="`required|numeric`"
            ></v-textfield-public>
          </li>
          <li class="form__item">
            <v-datepicker-public
              v-if="extra_tenants[i]"
              v-model="extra_tenants[i].wced"
              :label="usersContractEndDate"
              :name="
                `person[` + extra_tenants[i].id + `][working_contract_end_date]`
              "
              v-validate="`required`"
            ></v-datepicker-public>
            <v-datepicker-public
              v-else
              :label="usersContractEndDate"
              :name="`new_person[` + [i] + `][working_contract_end_date]`"
              v-validate="`required`"
            ></v-datepicker-public>
          </li>
        </template>
        <li class="form__item">
          <v-textfield-public
            v-if="extra_tenants[i]"
            :label="usersOccupation"
            :name="`person[` + extra_tenants[i].id + `][occupation]`"
            v-model="extra_tenants[i].occupation"
            v-validate="`required`"
          ></v-textfield-public>
          <v-textfield-public
            v-else
            :label="usersOccupation"
            :name="`new_person[` + [i] + `][occupation]`"
            v-validate="`required`"
          ></v-textfield-public>
        </li>
        <li class="form__item">
          <v-textfield-public
            v-if="extra_tenants[i]"
            :label="usersMonthlyIncome"
            :name="`person[` + extra_tenants[i].id + `][income]`"
            v-model="extra_tenants[i].income"
            v-validate="`required|numeric`"
          ></v-textfield-public>
          <v-textfield-public
            v-else
            :label="usersMonthlyIncome"
            :name="`new_person[` + [i] + `][income]`"
            v-validate="`required|numeric`"
          ></v-textfield-public>
          <div class="form__bottom-row">{{ usersMonthlyIncomeNote }}</div>
        </li>
        <li class="form__item">
          <v-radios-public
            v-if="extra_tenants[i]"
            :label="usersDoYouHaveGuarantorGeneral"
            :name="`person[` + extra_tenants[i].id + `][guarantor]`"
            :options="usersDoYouHaveGuarantorOptions"
            :value="extra_tenants[i].guarantor + ''"
            @input="triggerGuarantorForm"
            v-validate="`required|make_choice`"
          ></v-radios-public>
          <v-radios-public
            v-else
            :label="usersDoYouHaveGuarantorGeneral"
            :name="`new_person[` + [i] + `][guarantor]`"
            :options="usersDoYouHaveGuarantorOptions"
            @input="triggerGuarantorForm"
            v-validate="`required|make_choice`"
          ></v-radios-public>
        </li>
        <li v-if="guarantor_form_state == 1" class="form__item">
          <v-textfield-public
            v-if="extra_tenants[i]"
            :label="usersGuarantorIncome"
            :name="`person[` + extra_tenants[i].id + `][guarantor_income]`"
            v-model="extra_tenants[i].guarantor_income"
            v-validate="`required|numeric`"
          ></v-textfield-public>
          <v-textfield-public
            v-else
            :label="usersGuarantorIncome"
            :name="`new_person[` + [i] + `][guarantor_income]`"
            v-validate="`required|numeric`"
          ></v-textfield-public>
        </li>
      </template>
      <!-- studying -->
      <template v-if="income_form_studying">
        <template v-if="!income_form_work_business">
          <li class="form__item">
            <v-radios-public
              v-if="extra_tenants[i]"
              :label="usersDoYouHaveGuarantor"
              :name="`person[` + extra_tenants[i].id + `][guarantor]`"
              :options="usersDoYouHaveGuarantorOptions"
              :value="extra_tenants[i].guarantor"
              @input="triggerGuarantorForm"
              v-validate="`required|make_choice`"
            ></v-radios-public>
            <v-radios-public
              v-else
              :label="usersDoYouHaveGuarantor"
              :name="`new_person[` + [i] + `][guarantor]`"
              :options="usersDoYouHaveGuarantorOptions"
              @input="triggerGuarantorForm"
              v-validate="`required|make_choice`"
            ></v-radios-public>
          </li>
          <!-- <li v-if="guarantor_form_state == 0 || guarantor_form_state == 2" class="form__item">
					<v-radios-public 
						v-if='extra_tenants[i]' 
						:label="usersDoYouHaveOtherGuaranteeOptions"
						:name="`person[`+extra_tenants[i].id+`][extra_guarantor]`" 
						:options="usersDoYouHaveOtherGuaranteeOptionsOptions" 
						v-validate="`required|make_choice`">
					</v-radios-public>
					<v-radios-public 
						v-else 
						:label="usersDoYouHaveOtherGuaranteeOptions"
						:name="`new_person[`+[i]+`][extra_guarantor]`" 
						:options="usersDoYouHaveOtherGuaranteeOptionsOptions" 
						v-validate="`required|make_choice`">
					</v-radios-public>
          </li>-->
          <li v-if="guarantor_form_state == 1" class="form__item">
            <v-textfield-public
              v-if="extra_tenants[i]"
              :label="usersGuarantorIncome"
              :name="`person[` + extra_tenants[i].id + `][guarantor_income]`"
              v-model="extra_tenants[i].guarantor_income"
              v-validate="`required|numeric`"
            ></v-textfield-public>
            <v-textfield-public
              v-else
              :label="usersGuarantorIncome"
              :name="`new_person[` + [i] + `][guarantor_income]`"
              v-validate="`required|numeric`"
            ></v-textfield-public>
          </li>
        </template>
        <li class="form__item">
          <v-textfield-public
            v-if="extra_tenants[i]"
            :label="usersStudy"
            :name="`person[` + extra_tenants[i].id + `][study]`"
            v-model="extra_tenants[i].study"
            v-validate="`required`"
          ></v-textfield-public>
          <v-textfield-public
            v-else
            :label="usersStudy"
            :name="`new_person[` + [i] + `][study]`"
            v-validate="`required`"
          ></v-textfield-public>
        </li>
      </template>
      <li v-if="income_form_any" class="form__item form__item--align-start">
        <label class="form__label">{{ usersExtraInformationIncome }}</label>
        <textarea
          v-if="extra_tenants[i]"
          class="form__textarea"
          :name="`person[` + extra_tenants[i].id + `][income_note]`"
          v-model="extra_tenants[i].income_note"
        ></textarea>
        <textarea
          v-else
          class="form__textarea"
          :name="`new_person[` + [i] + `][income_note]`"
        ></textarea>
      </li>
    </ul>
    <div class="form__heading">
      <h2 class="form__title">
        {{ subscriptions }} {{ i + 2 }}
        {{
          locales &&
          locales.users &&
          locales.users.landlord_details.toLowerCase()
        }}
      </h2>
    </div>
    <ul class="form__list">
      <li class="form__item">
        <v-radios-public
          v-if="extra_tenants[i]"
          :label="
            locales && locales.users && locales.users.who_is_your_landlord
          "
          :name="`person[` + extra_tenants[i].id + `][landlord_status]`"
          :options="usersLandlordOptions"
          v-model="extra_tenants[i].landlord_status"
          @input="triggerLandlordType"
        ></v-radios-public>
        <v-radios-public
          v-else
          :label="
            locales && locales.users && locales.users.who_is_your_landlord
          "
          :name="`new_person[` + [i] + `][landlord_status]`"
          :options="usersLandlordOptions"
          @input="triggerLandlordType"
        ></v-radios-public>
      </li>
      <li v-if="landlord_type_state == 'renting_property'" class="form__item">
        <ul class="form__list">
          <li class="form__item">
            <v-textfield-public
              v-if="extra_tenants[i]"
              :label="locales && locales.users && locales.users.landlord_name"
              :name="`person[` + extra_tenants[i].id + `][landlord_name]`"
            ></v-textfield-public>
            <v-textfield-public
              v-else
              :label="locales && locales.users && locales.users.landlord_name"
              :name="`new_person[` + [i] + `][landlord_name]`"
            ></v-textfield-public>
          </li>
          <li class="form__item">
            <v-textfield-public
              v-if="extra_tenants[i]"
              :label="locales && locales.users && locales.users.landlord_email"
              :name="`person[` + extra_tenants[i].id + `][landlord_email]`"
              v-validate="`email`"
            ></v-textfield-public>
            <v-textfield-public
              v-else
              :label="locales && locales.users && locales.users.landlord_email"
              :name="`new_person[` + [i] + `][landlord_email]`"
              v-validate="`email`"
            ></v-textfield-public>
          </li>
          <li class="form__item">
            <v-textfield-public
              v-if="extra_tenants[i]"
              :label="
                locales && locales.users && locales.users.landlord_phone_number
              "
              :name="
                `person[` + extra_tenants[i].id + `][landlord_phone_number]`
              "
              v-validate="`phone_number`"
            ></v-textfield-public>
            <v-textfield-public
              v-else
              :label="
                locales && locales.users && locales.users.landlord_phone_number
              "
              :name="`new_person[` + [i] + `][landlord_phone_number]`"
              v-validate="`phone_number`"
            ></v-textfield-public>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  inject: ["$validator"],
  data() {
    return {
      income_form_any: false,
      income_form_studying: false,
      income_form_work: false,
      income_form_work_business: false,
      extra_tenants: this.extraTenants,
      income_form_all_states: this.incomeFormAllStates,
      income_form_state: -1,
      guarantor_form_state: -1,
      is_user_already_exists: 0,
      landlord_type_state: this.landlordTypeState,
      showDuration: false,
      is_phone_number_unique: 0,
    };
  },
  computed: {
    ...mapGetters(["locales"]),
  },
  props: {
    i: {
      default: 0,
      type: Number,
    },
    subscriptions: {
      default: "",
      type: String,
    },
    extraTenants: {
      default: () => {},
      type: [Object, Array],
    },
    usersFirstName: {
      default: "",
      type: String,
    },
    usersTitleOptions: {
      default: () => {},
      type: Object,
    },
    usersMiddleName: {
      default: "",
      type: String,
    },
    usersLastName: {
      default: "",
      type: String,
    },
    usersDateOfBirth: {
      default: "",
      type: String,
    },
    usersPhoneNumber: {
      default: "",
      type: String,
    },
    usersEmail: {
      default: "",
      type: String,
    },
    usersInvoiceEmail: {
      default: "",
      type: String,
    },
    usersBankAccount: {
      default: "",
      type: String,
    },
    usersBic: {
      default: "",
      type: String,
    },
    usersCivilState: {
      default: "",
      type: String,
    },
    usersCivilStateOptions: {
      default: () => {},
      type: Object,
    },
    usersIAm: {
      default: "",
      type: String,
    },
    usersTypeOfIncomeOptions: {
      default: () => {},
      type: Object,
    },
    usersTypeOfIncomeSlugs: {
      default: () => {},
      type: Object,
    },
    usersContractType: {
      default: "",
      type: String,
    },
    usersContractTypeInput: {
      default: "",
      type: String,
    },
    usersContractTypeOptions: {
      default: () => {},
      type: [Object, Array],
    },
    usersContractTypeAttributes: {
      default: () => {},
      type: [Object, Array],
    },
    usersContractDuration: {
      default: "",
      type: String,
    },
    usersContractDurationInput: {
      default: "",
      type: String,
    },
    usersContractEndDate: {
      default: "",
      type: String,
    },
    usersContractEndDateInput: {
      default: "",
      type: String,
    },
    usersOccupation: {
      default: "",
      type: String,
    },
    usersMonthlyIncome: {
      default: "",
      type: String,
    },
    usersMonthlyIncomeNote: {
      default: "",
      type: String,
    },
    usersDoYouHaveGuarantor: {
      default: "",
      type: String,
    },
    usersDoYouHaveGuarantorGeneral: {
      default: "",
      type: String,
    },
    usersDoYouHaveGuarantorOptions: {
      default: () => {},
      type: Object,
    },
    usersDoYouHaveOtherGuaranteeOptions: {
      default: "",
      type: String,
    },
    usersDoYouHaveOtherGuaranteeOptionsOptions: {
      default: () => {},
      type: Object,
    },
    usersGuarantorIncome: {
      default: "",
      type: String,
    },
    usersStudy: {
      default: "",
      type: String,
    },
    usersExtraInformationIncome: {
      default: "",
      type: String,
    },
    incomeFormAllStates: {
      default: () => [],
      type: Array,
    },
    incomeTitle: {
      default: "",
      type: String,
    },
    landlordTypeState: {
      default: "-1",
      type: String,
    },
    usersLandlordOptions: {
      default: () => {},
      type: Object,
    },
    isUserAlreadyExists: {
      default: "",
      type: String,
    },
    isUserBanned: {
      default: "",
      type: String,
    },
    incomePhoneNumberAlreadyExists: {
      default: "",
      type: String,
    },
    languages: {
      default: () => {},
      type: Object,
    },
  },
  methods: {
    triggerIncomeAdditionalForms: function (value) {
      if (value) {
        this.income_form_state = value;
      } else {
        if (this.extraTenants[this.i]) {
          this.income_form_state =
            this.extraTenants[this.i].types_of_income_array;
        } else {
          this.income_form_state = -1;
        }
      }

      this.income_form_any = false;
      this.income_form_studying = false;
      this.income_form_work_business = false;
      this.income_form_work = false;

      for (var i = 0; i < this.income_form_state.length; i++) {
        var state = this.usersTypeOfIncomeSlugs[this.income_form_state[i]];

        if (this.income_form_all_states.indexOf(state) > -1) {
          this.income_form_any = true;
          if (state == "own_business" || state == "working") {
            this.income_form_work_business = true;
          }
          if (state == "working") {
            this.income_form_work = true;
          }
          if (state == "studying") {
            this.income_form_studying = true;
          }
        }
      }
    },
    triggerContractDuration: function (value) {
      this.showDuration = false;
      if (value) {
        var option = this.usersContractTypeAttributes[value];
        if (option == "1") {
          this.showDuration = true;
        }
      } else {
        if (this.extraTenants[this.i]) {
          var option =
            this.usersContractTypeAttributes[
              this.extraTenants[this.i].working_contract_type_id
            ];
          if (option == "1") {
            this.showDuration = true;
          }
        }
      }
    },
    triggerGuarantorForm: function (value) {
      if (value) {
        if (value !== true) {
          this.guarantor_form_state = value;
        } else {
          this.guarantor_form_state = -1;
        }
      } else {
        if (this.extraTenants[this.i]) {
          this.guarantor_form_state = this.extraTenants[this.i].guarantor;
        } else {
          this.guarantor_form_state = -1;
        }
      }
    },
    triggerLandlordType: function (value) {
      this.landlord_type_state = value;
    },
    checkMail: function (event, id = null) {
      var email = event.target.value;
      if (email == "") return (this.is_user_already_exists = 0);
      var vm = this;
      var data = {
        email: email,
      };
      if (id) {
        data.id = id;
      }
      $.ajax({
        url: `/api/users/check-mail`,
        method: "post",
        data: data,
        success: function (result) {
          vm.is_user_already_exists = +result;
          if (result == 0) {
            var elements = document.getElementsByClassName("js-unique-mail");
            var mails = [];
            Array.prototype.forEach.call(elements, function (el) {
              // Do stuff here
              let val = el.querySelector("input").value;
              if (el.querySelector("input") != event.target && val != "") {
                mails.push(val);
              }
            });
            if (mails.length && mails.indexOf(email) != -1) {
              vm.is_user_already_exists = 1;
            } else {
              vm.is_user_already_exists = 0;
            }
          }
        },
        error: function () {},
      });
    },
    checkPhone: function (event) {
      var phone = event.target.value;
      if (phone == "") return (this.is_phone_number_unique = 0);
      var vm = this;
      var elements = document.getElementsByClassName("js-unique-phone");
      var phones = [];
      Array.prototype.forEach.call(elements, function (el) {
        // Do stuff here
        let val = el.querySelector("input").value;
        if (el.querySelector("input") != event.target && val != "") {
          phones.push(val);
        }
      });
      if (phones.length && phones.indexOf(phone) != -1) {
        vm.is_phone_number_unique = 1;
      } else {
        vm.is_phone_number_unique = 0;
      }
    },
    checkPcHn(event, i) {
      this.validated = false;
      this.changed = true;
      var that = this;
      setTimeout(function () {
        if (that.extra_tenants[i]) {
          var postcode = $(
            "[name='person[" +
              that.extra_tenants[i].id +
              "][address][post_code]']"
          )
            .first()
            .val();
          var house_number = $(
            "[name='person[" +
              that.extra_tenants[i].id +
              "][address][house_number]']"
          )
            .first()
            .val();
          if (postcode && postcode != "") {
            $.post(
              "/get-street-location",
              {
                postcode: postcode,
                house_number: house_number,
              },
              function (data) {
                if (data.error == "false") {
                  $(
                    "[name='person[" +
                      that.extra_tenants[i].id +
                      "][address][city]']"
                  )
                    .first()
                    .val(data.location);
                  that.extra_tenants[i].address.city = data.location;
                  $(
                    "[name='person[" +
                      that.extra_tenants[i].id +
                      "][address][street]']"
                  )
                    .first()
                    .val(data.street);
                  that.extra_tenants[i].address.street = data.street;
                }
              },
              "json"
            );
          }
        } else {
          var postcode = $(
            "[name='new_person[" + [i] + "][address][post_code]']"
          )
            .first()
            .val();
          var house_number = $(
            "[name='new_person[" + [i] + "][address][house_number]']"
          )
            .first()
            .val();
          if (postcode && postcode != "") {
            $.post(
              "/get-street-location",
              {
                postcode: postcode,
                house_number: house_number,
              },
              function (data) {
                if (data.error == "false") {
                  $("[name='new_person[" + [i] + "][address][city]']")
                    .first()
                    .val(data.location);
                  $("[name='new_person[" + [i] + "][address][street]']")
                    .first()
                    .val(data.street);
                  var ref1 = "new_person_street_" + i;
                  var ref2 = "new_person_city_" + i;
                  that.$refs[ref1].model = data.street;
                  that.$refs[ref2].model = data.location;
                }
              },
              "json"
            );
          }
        }
      }, 100);
    },
    checkPostcodeAddress(event, i) {
      this.validated = false;
      this.changed = true;
      var that = this;
      setTimeout(function () {
        if (that.extra_tenants[i]) {
          var street = $(
            "[name='person[" + that.extra_tenants[i].id + "][address][street]']"
          )
            .first()
            .val();
          var house_number = $(
            "[name='person[" +
              that.extra_tenants[i].id +
              "][address][house_number]']"
          )
            .first()
            .val();
          var location = $(
            "[name='person[" + that.extra_tenants[i].id + "][address][city]']"
          )
            .first()
            .val();
          if (street != "" && house_number != "") {
            $.post(
              `/get-postcode-by-address`,
              {
                street: street,
                house_number: house_number,
                location: location,
              },
              function (data) {
                if (data.error == "false") {
                  $(
                    "[name='person[" +
                      that.extra_tenants[i].id +
                      "][address][post_code]']"
                  )
                    .first()
                    .val(data.postcode);
                  that.extra_tenants[i].address.post_code = data.postcode;
                }
              },
              "json"
            );
          }
        } else {
          var street = $("[name='new_person[" + [i] + "][address][street]']")
            .first()
            .val();
          var house_number = $(
            "[name='new_person[" + [i] + "][address][house_number]']"
          )
            .first()
            .val();
          var location = $("[name='new_person[" + [i] + "][address][city]']")
            .first()
            .val();
          if (street != "" && house_number != "") {
            $.post(
              `/get-postcode-by-address`,
              {
                street: street,
                house_number: house_number,
                location: location,
              },
              function (data) {
                if (data.error == "false") {
                  $("[name='new_person[" + [i] + "][address][post_code]']")
                    .first()
                    .val(data.postcode);
                  var ref1 = "new_person_postcode_" + i;
                  that.$refs[ref1].model = data.postcode;
                }
              },
              "json"
            );
          }
        }
      }, 100);
    },
  },
  beforeMount() {
    this.triggerIncomeAdditionalForms();
    this.triggerGuarantorForm();
    this.triggerContractDuration();
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/admin/components/VDetailsInnerForm.vue